import { render, staticRenderFns } from "./Choose.vue?vue&type=template&id=e55bc938&scoped=true"
import script from "./Choose.vue?vue&type=script&lang=js"
export * from "./Choose.vue?vue&type=script&lang=js"
import style0 from "./Choose.vue?vue&type=style&index=0&id=e55bc938&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e55bc938",
  null
  
)

export default component.exports